// extracted by mini-css-extract-plugin
module.exports = {"h1":"Htag_h1__weCcj","h2":"Htag_h2__BpTjh","h3":"Htag_h3__C88aX","h4":"Htag_h4__xSaUa"};